package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.TextareaDemo
import example.shadcn_kotlin.ui.pages.components.demo.TextareaDisabled
import example.shadcn_kotlin.ui.pages.components.demo.TextareaWithText
import example.shadcn_kotlin.ui.pages.components.demo.TextareaWithLabel
import example.shadcn_kotlin.ui.pages.components.demo.TextareaWithButton

@Page
@Composable
fun TextareaPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/textarea.md", mapOf("title" to listOf("Textarea"), "description" to listOf("Displays a form textarea or a component that looks like a textarea.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Textarea

val TextareaDemo = FC<Props> {
    Textarea {
        placeholder="Type your message here."
    }
}"""){ 
 TextareaDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Textarea
""", lang= "kotlin", highlight= "")
            CodeBlock("""Textarea {}
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("default")
 }) {
                org.jetbrains.compose.web.dom.Text("Default")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Textarea

val TextareaDemo = FC<Props> {
    Textarea {
        placeholder="Type your message here."
    }
}"""){ 
 TextareaDemo {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("disabled")
 }) {
                org.jetbrains.compose.web.dom.Text("Disabled")
            }
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.Textarea

val TextareaDisabled = FC<Props> {
    Textarea {
        placeholder = "Type your message here."
        disabled = true
    }
}"""){ 
 TextareaDisabled {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("with-label")
 }) {
                org.jetbrains.compose.web.dom.Text("With Label")
            }
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.Label
import shadcn.ui.components.Textarea
import web.cssom.ClassName

val TextareaWithLabel = FC<Props> {
    div {
        className = ClassName("grid w-full gap-1.5")
        Label {
            htmlFor="message"
            + "Your message"
        }
        Textarea {
            placeholder="Type your message here."
            id="message"
        }
    }
}"""){ 
 TextareaWithLabel {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("with-text")
 }) {
                org.jetbrains.compose.web.dom.Text("With Text")
            }
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import shadcn.ui.components.Label
import shadcn.ui.components.Textarea
import web.cssom.ClassName

val TextareaWithText = FC<Props> {
    div {
        className = ClassName("grid w-full gap-1.5")
        Label {
            htmlFor = "message-2"
            +"Your message"
        }
        Textarea {
            placeholder = "Type your message here."
            id = "message-2"
        }
        p {
            className = ClassName("text-sm text-muted-foreground")
            + "Your message will be copied to the support team."
        }
    }
}"""){ 
 TextareaWithText {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("with-button")
 }) {
                org.jetbrains.compose.web.dom.Text("With Button")
            }
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.Button
import shadcn.ui.components.Textarea
import web.cssom.ClassName

val TextareaWithButton = FC<Props> {
    div {
        className = ClassName("grid w-full gap-2")
        Textarea { placeholder = "Type your message here." }
        Button { +"Send message" }

    }
}"""){ 
 TextareaWithButton {} 
 }
        }
    }
}
